import { useBookingDraftQuery } from '@/scopes/checkout/domain/hooks'
import { Button, tk, Typography } from '@sunwebgroup/ui-components'
import { Icon } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const PreviousStepButton = styled(Button)`
  color: ${tk('color_semantic_text_strong')};
  width: fit-content;
  padding: 0;
`

export function CheckoutPreviousStep() {
  const { isLoading, data } = useBookingDraftQuery()

  const previousStep = data?.navigation?.previousStep
  if (!previousStep)
    return null

  const goToPreviousStep = () => {
    window.location.href = previousStep.url
  }

  return (
    <PreviousStepButton
      $hierarchy="tertiary"
      $withoutColor
      $size="default"
      onClick={goToPreviousStep}
      disabled={isLoading}
      data-qa="checkout-previous-step-button"
    >
      <Icon glyph="ChevronLeft" size={24} />
      <Typography $variant="label">{previousStep.text}</Typography>
    </PreviousStepButton>
  )
}
